
export function getMediaQ() {
  if (window.innerWidth >= '1200') return 'desklg';
  if (window.innerWidth >= '992') return 'desk';
  if (window.innerWidth >= '768') return 'tab';
  return 'mob';
}
